export default __webpack_public_path__ + "static/media/extraCoffee.5a1d13b2.jpg";